<template>
  <div>
    <Header title="学籍预警" type='0' route="/homeIndex"></Header>
    <div class="warn-tab">
      <router-link to="/student/curWarn" tag="li">当前预警</router-link>
      <router-link to="/student/allWarn" tag="li">全部预警</router-link>
    </div>
    <div>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
  export default {
    methods:{

    }
  }
</script>

<style lang="less" scoped>
  .warn-tab{padding: 20px 0 7px;border-bottom: 1px solid @attendance-border-color-6;display: flex;justify-content: center;}
  .warn-tab li{margin: 0 32px;color: @attendance-color-2 ;font-size: 14px;list-style: none;}
  .warn-tab .router-link-exact-active.router-link-active{color: @attendance-color-1;font-weight: 600;}
</style>



// WEBPACK FOOTER //
// src/components/student/statusManage/warning.vue